
import template from './confirm_account_dialog.html';

var ConfirmAccountDialogViewModel = function (page) {
	var self = this;
	self.page = page;
	this.type = ko.observable();
	this.installation_uuid = ko.observable();
	this.install_status = ko.observable('Initial');
	this.alert_message = ko.observable('');
	this.system_url = ko.observable('');
}

var ConfirmAccountDialogClass = function (bindings) {
	var self = this;
	this.self = self;
	this.bindings = bindings;
	this.get_account_installation_status_timeout;
	this.viewModel = new ConfirmAccountDialogViewModel(this);
	window.debugdialog = this;

	this.init = () => {
		this.viewModel.installation_uuid(bindings.installation_uuid);
		this.viewModel.install_status.subscribe( new_value => {
			console.log(new_value);
			if (!['Pending Activation', 'Pending Install', 'Installing', 'Installed', 'Pending Upgrade', 'Upgrading', 'Upgraded'].includes(new_value)){
				clearTimeout(this.get_account_installation_status_timeout);
				return;
			}

			switch (new_value) {
				case 'Pending Activation':
					clearTimeout(this.get_account_installation_status_timeout);
					this.close();
					break;
				case 'Pending Install':
					this.viewModel.type('Install');
					this.progress_bar_update($('.bar'));
					break;
				case 'Pending Upgrade':
					this.viewModel.type('Upgrade');
					this.progress_bar_update($('.bar'));
					break;
				case 'Installing':
					this.viewModel.type('Install');
					this.progress_bar_update($('.bar'));
					break;
				case 'Upgrading':
					this.viewModel.type('Upgrade');
					this.progress_bar_update($('.bar'));
					break;
				case 'Installed':
				case 'Upgraded':
					console.log('Installed/Upgraded');
					break;
				case 'Started':
					clearTimeout(this.get_account_installation_status_timeout);
					//should update showing success
					break;
				case 'Install Error':
				case 'Upgrade Error':
					clearTimeout(this.get_account_installation_status_timeout);
					break;
				default:
					clearTimeout(this.get_account_installation_status_timeout);
			}
		});
		this.get_account_installation_status();
	};

	//Event (Post/After): Refresh page data
	// this.updateData = () => {
	// 	// self.wait_until_is_done(self.viewModel.install_status());
	// 	this.get_account_installation_status();
	// };

	this.get_account_installation_status = () => {
		clearTimeout(this.get_account_installation_status_timeout);
		this.get_account_installation_status_timeout = setTimeout(()=>{
			$.postJSON("/psam/api/account/installation/status",
				{ installation_uuid: this.viewModel.installation_uuid() }
			)
			.then( res => {
				if (res.status === 'ERROR') {
					Grape.alert_api_error(res);
					return;
				}

				this.viewModel.system_url(`https://${res.account_installation.fqdn}`);
				this.viewModel.install_status(res.account_installation.status);

				if (['Pending Install', 'Installing', 'Pending Upgrade', 'Upgrading'].includes(res.account_installation.status))
					this.get_account_installation_status();
			})
			.catch( err => {
				Grape.alert_api_error(err);
				this.close();
				return;
			});
		}, 1000);
	}

	this.progress_bar_update = function (bar) {
		bar.stop();
		bar.animate(
			{width:'100%'},
			{duration:180000, easing:'swing', step:(n, fx) => {
				bar.text(`${Math.round(n)}%`);
			}}
		);
		// var barWidthPercentage = Math.ceil(bar.width() / bar.parent().width() * 100);
		// bar.width(`${barWidthPercentage + Math.ceil((100-barWidthPercentage)*0.01)}%`);
		// bar.text(`${barWidthPercentage}%`);
	}

	this.teardown = () => {
		clearTimeout(this.get_account_installation_status_timeout);
	}

	this.onClose = function () {
		clearTimeout(this.get_account_installation_status_timeout);
	};

	this.btnclose = function () {
		clearTimeout(this.get_account_installation_status_timeout);
		self.close(false);
	};

}

//Register the dialog
export default {
    name: 'ConfirmAccountDialog',
    dialog_class: ConfirmAccountDialogClass,
    template: template
};
